module.exports = __webpack_public_path__ + "static/img/ggsc3.48d8f2e.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/common/ggsc3.jpg
// module id = bfbR
// module chunks = 0